import { useT } from "../i18n/LanguageContext";

function Flag({ country }) {
    if (country === "us") {
        return (
            <svg width="14" height="10" viewBox="0 0 14 10" aria-hidden>
                <rect width="14" height="10" fill="#b22234" />
                <g fill="#fff">
                    <rect y="1" width="14" height="1" />
                    <rect y="3" width="14" height="1" />
                    <rect y="5" width="14" height="1" />
                    <rect y="7" width="14" height="1" />
                    <rect y="9" width="14" height="1" />
                </g>
                <rect width="6" height="5" fill="#3c3b6e" />
            </svg>
        );
    }
    if (country === "es") {
        return (
            <svg width="14" height="10" viewBox="0 0 14 10" aria-hidden>
                <rect width="14" height="10" fill="#c60b1e" />
                <rect y="2.5" width="14" height="5" fill="#ffc400" />
            </svg>
        );
    }
    if (country === "it") {
        return (
            <svg width="14" height="10" viewBox="0 0 14 10" aria-hidden>
                <rect width="4.667" height="10" fill="#009246" />
                <rect x="4.667" width="4.666" height="10" fill="#fff" />
                <rect x="9.333" width="4.667" height="10" fill="#ce2b37" />
            </svg>
        );
    }
    if (country === "fr") {
        return (
            <svg width="14" height="10" viewBox="0 0 14 10" aria-hidden>
                <rect width="4.667" height="10" fill="#0055a4" />
                <rect x="4.667" width="4.666" height="10" fill="#fff" />
                <rect x="9.333" width="4.667" height="10" fill="#ef4135" />
            </svg>
        );
    }
    return null;
}

const LANGS = [
    { code: "en", country: "us" },
    { code: "es", country: "es" },
    { code: "it", country: "it" },
    { code: "fr", country: "fr" },
];

export default function LanguageSwitcher() {
    const { lang, setLang, t } = useT();
    const base =
        "inline-flex items-center gap-1.5 px-2.5 py-1.5 text-[10px] tracking-[0.25em] uppercase font-semibold transition-colors";
    const activeCls = "bg-gold/10 text-gold border-gold/40";
    const idleCls = "text-white/50 hover:text-white";

    return (
        <div
            className="inline-flex items-center border border-white/15 rounded-none overflow-hidden"
            data-testid="language-switcher"
            aria-label="Language switcher"
        >
            {LANGS.map((l, i) => {
                const isActive = lang === l.code;
                return (
                    <div key={l.code} className="flex items-center">
                        {i > 0 && <span className="w-px h-4 bg-white/15" />}
                        <button
                            type="button"
                            onClick={() => setLang(l.code)}
                            className={`${base} ${isActive ? activeCls : idleCls}`}
                            aria-pressed={isActive}
                            aria-label={t(`lang.${l.code}`)}
                            data-testid={`lang-${l.code}`}
                        >
                            <Flag country={l.country} />
                            <span className="hidden xl:inline">
                                {t(`lang.${l.code}`)}
                            </span>
                        </button>
                    </div>
                );
            })}
        </div>
    );
}
